import { addDays, format, isBefore, parseISO, startOfDay } from 'date-fns';

import { effectiveDateFormSchema } from './schema';
import { EffectiveDateOption, PresetEffectiveDateOption } from './types';

const SAO_PAULO_TIME_ZONE = 'America/Sao_Paulo';
const MONDAY = 1;
const DAYS_IN_WEEK = 7;

const saoPauloDateFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: SAO_PAULO_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

// Local midnight of the civil date in São Paulo at the given instant.
export const getSaoPauloToday = (now: Date = new Date()): Date => parseISO(saoPauloDateFormatter.format(now));

// First Monday strictly after `today`.
export const getNextMonday = (today: Date): Date => {
  const daysUntilMonday = (MONDAY - today.getDay() + DAYS_IN_WEEK) % DAYS_IN_WEEK || DAYS_IN_WEEK;
  return addDays(today, daysUntilMonday);
};

const PRESET_DATE_RESOLVERS: Record<PresetEffectiveDateOption, (today: Date) => Date> = {
  TODAY: today => today,
  TOMORROW: today => addDays(today, 1),
  NEXT_MONDAY: getNextMonday,
};

export const resolvePresetDate = (option: PresetEffectiveDateOption, today: Date): Date => PRESET_DATE_RESOLVERS[option](today);

export const toApiDate = (date: Date): string => format(date, 'yyyy-MM-dd');

export const formatDayMonth = (date: Date): string => format(date, 'dd/MM');

export const isBeforeToday = (date: Date, today: Date): boolean => isBefore(startOfDay(date), today);

export const EFFECTIVE_DATE_OPTION_ORDER: readonly EffectiveDateOption[] = effectiveDateFormSchema.shape.option.options;

export const EFFECTIVE_DATE_OPTIONS: Record<EffectiveDateOption, { label: string; description: string }> = {
  TODAY: { label: 'Hoje', description: 'Aplicamos o novo preço com a data de hoje,' },
  TOMORROW: { label: 'Amanhã', description: 'Aplicamos o novo preço com a data de amanhã,' },
  NEXT_MONDAY: { label: 'Próxima segunda', description: 'Aplicamos o novo preço com a data da próxima segunda-feira,' },
  CUSTOM: { label: 'Data específica', description: 'Você escolhe a data de início da vigência.' },
};
